var render = function render(){var _vm=this,_c=_vm._self._c;return _c('i',{class:`${_vm.prefix} fa-${_vm.icon}`,on:{"click":function($event){return _vm.$emit('click', $event)}}})
}
var staticRenderFns = []

export { render, staticRenderFns }